import Mixin from "../../mixin.js";
import Utils from "../../services/utils-service.js";
import Label from "./Label.js";
import Funnel from "../../services/funnel-service.js";

const template = `
<div v-show="fs.display(input)">
    <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_announcer'"></div>
    <div class="spinner" :class="iuid+ '-container'">
        <div class="card" :ref="input.uid+'_card'" role="group" tabindex="0">
            <qt-label :iuid="iuid" :img="fs.icon(input)"></qt-label>
            <small class="sr-only" id="sr-help-spinner" >You cycle through the options by interacting with the add and subtract buttons using your keyboard or assistive device.</small>
            <div class="spinner-container">
                <button
                    type="button" 
                    class="subtract"
                    @click="subtract();hanldeExec($event, input)"
                    @keydown="handleKeydown($event, input)"
                    tabindex="0"
                    role="button"
                    :data-uid="input.uid+'_btn_subtract'"
                    :ref="input.uid+'_btn_subtract'"
                    :aria-controls="input.uid"
                >
                    <img alt="minus" class="iconic iconic-sm"  data-src="/static/images/iconic/minus.svg">
                </button>
                <input
                    :uid="input.uid"
                    :type="spinnerType(input)"
                    :min="computedMin"
                    :max="computedMax"
                    :id="input.uid"
                    :required="input.validation.required"
                    :name="input.element_name"
                    :value="showValue"
                    :disabled="setDisabled(input.disabled)"
                    v-bind="validationRules"
                    v-maska="computedMask"
                    :data-uid="input.uid"
                    aria-describedby="sr-help-spinner"
                    class="input-spinner"
                    role="spinbutton"
                    :aria-valuenow="showValue"
                    :aria-valuemin="(spinnerType(input)=='number') ? computedMin : ''"
                    :aria-valuemax="(spinnerType(input) == 'number') ? computedMax : ''"
                    readonly
                />
                <button
                    type="button" 
                    class="add"
                    @click="add();hanldeExec($event, input)"
                    @keydown="handleKeydown($event, input)"
                    tabindex="0"
                    role="button"
                    :data-uid="input.uid+'_btn_add'"
                    :ref="input.uid+'_btn_add'"
                    :aria-controls="input.uid"
                >
                    <img alt="plus" class="iconic iconic-sm"src="/static/images/iconic/plus.svg">
                </button>
            </div>
        </div>
    </div>
    <div class="spinner-error"></div>
</div>
`;

export default {
    name: 'qt-input-spinner',
    template,
    props: ['iuid'],
    components: {
        'qt-label': Label
    },
    mixins: [Mixin],
    watch: {
        "input.loading": function (newVal, oldVal) {
           this.fs.elementAnnouncer(this.input)
        },
        "input.value": function (newVal, oldVal) {
            $("#"+this.input.id+'_announcer').text(this.input.label + ' has been updated to ' + newVal);
         }
    },
    computed: {
        computedValue: function(){
            if (!this.input.value) {return}
            var self = this
            var selectedOptionIndexArr = this.input.options.reduce(function(arr, o, i) {
              if (o.value == self.input.value) {
                arr.push(i);
              }
              return arr;
            }, []);
            var selectedOptionIndex = selectedOptionIndexArr[0]
            console.log(this.input.options[selectedOptionIndex]);

            return this.input.options[selectedOptionIndex].label



        },
        showValue: function(){
            if (!this.input.spinner_type || this.input.spinner_type == 1) {
                return this.input.value
            }
            else{
                return this.computedValue
            }
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        validationRules () {
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedMask:function(){
            return this.input.validation.mask
        },
        computedInputClass: function(){

            var statusClass = '';

            if (this.input.value) {
                statusClass ='complete'
            }
            return statusClass
        },
        computedMin: function(){
            if((this.spinnerType(this.input) == 'number') && this.input.min != undefined){
                return this.input.min
            }
        },
        computedMax: function(){
            if((this.spinnerType(this.input) == 'number') && this.input.max != undefined){
                return this.input.max
            }
        }
    },
    mounted: function(){
        if (!this.input.spinner_type || this.input.spinner_type == 1) {
        }
        else{
            if (!this.input.value) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: this.input.options[0].value });
            }

        }
       this.computedAriaLabel ()
    },
    methods: {
        handleKeydown: function(event, input){
            var classes = event.target.classList.value;

            console.log();

            if (event.target === this.$refs[this.input.uid+"_btn_subtract"])  {
                if (event.key === ' ' || event.key === 'Enter') {
                    event.preventDefault()
                    this.$refs[this.input.uid+"_btn_subtract"].click();
                   
                }
            }
            if (event.target === this.$refs[this.input.uid+"_btn_add"])  {
                if (event.key === ' ' || event.key === 'Enter') {
                    event.preventDefault()
                    this.$refs[this.input.uid+"_btn_add"].click();
                }
            }
            
        },
        spinnerType: function(){
            if (!this.input.spinner_type || this.input.spinner_type == 1) {
                return 'number'
            }else{
                return 'text'
            }
        },
        setDisabled(disabled) {
            return Utils.isTruthy(disabled);
        },
        add: function(){
            if (!this.input.spinner_type || this.input.spinner_type == 1) {
                var nextNumber = parseInt(this.input.value +1)
                var self = this

                this.$nextTick(function(){
                    if (nextNumber > self.input.max || self.input.value == self.input.max){
                        self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val: parseInt(self.input.max) });
                    }else{
                        self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val: nextNumber });
                    }
                    
                })
            }
            else{
                console.log('else');
                var self = this
                var totalOptions = this.input.options.length -1
                var selectedOptionIndexArr = this.input.options.reduce(function(arr, o, i) {
                  if (o.value == self.input.value) {
                    arr.push(i);
                  }
                  return arr;
                }, []);
                var selectedOptionIndex = selectedOptionIndexArr[0]

                console.log(selectedOptionIndex, totalOptions);
                if (selectedOptionIndex >= totalOptions) {
                    var nextOption = this.input.options[totalOptions]
                }else{
                    let nextIndx = selectedOptionIndex + 1

                    if(!this.fs.display(this.input.options[nextIndx])){
                        let indxAvailable = false;
                        for(let indx = nextIndx; indx <= totalOptions; indx++){
                            if(this.fs.display(this.input.options[indx])){
                                nextIndx = indx;
                                indxAvailable = true
                                break;
                            }
                        }

                        if(!indxAvailable){
                            nextIndx = selectedOptionIndex
                        }
                    }

                    var nextOption = this.input.options[nextIndx]
                }
                

                this.$nextTick(function(){
                    self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val:nextOption.value});
                });
            }
        },
        subtract: function(){
           if (!this.input.spinner_type || this.input.spinner_type == 1) {
                var nextNumber = parseInt(this.input.value -1)
                var self = this

                this.$nextTick(function(){
                    if (nextNumber <= self.input.min ){
                        self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val: parseInt(self.input.min) });
                    }else{
                        self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val: nextNumber });
                    }
                    
                })
                
                
            }else{
                var self = this
                var totalOptions = this.input.options.length -1
                var selectedOptionIndexArr = this.input.options.reduce(function(arr, o, i) {
                  if (o.value == self.input.value) {
                    arr.push(i);
                  }
                  return arr;
                }, []);
                var selectedOptionIndex = selectedOptionIndexArr[0]

                if (selectedOptionIndex == 0) {
                    var prevOption = this.input.options[0]
                }else{
                    let prevIndx = selectedOptionIndex - 1

                    if(!this.fs.display(this.input.options[prevIndx])){
                        let indxAvailable = false;
                        for(let indx = prevIndx; indx >= 0; indx--){
                            if(this.fs.display(this.input.options[indx])){
                                prevIndx = indx;
                                indxAvailable = true
                                break;
                            }
                        }

                        if(!indxAvailable){
                            prevIndx = selectedOptionIndex
                        }
                    }

                    var prevOption = this.input.options[prevIndx]
                }
                this.$nextTick(function(){
                    self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val:prevOption.value});
                })
            }
        },
        hanldeExec: function (e, input) {
            this.$nextTick(() => {
                this.exec(e, input, { skipUpdate: true });
            });
        },
        isTruthy: function (val) {
            return Utils.isTruthy(val);
        },
        getType: function () {
            var type = 'text';
            if (Utils.isTruthy(this.input.hidden)) {
                type = 'hidden';
            }
            if (this.input.type =='tel') {
                type = this.input.type
            }
            return type;
        },
        computedAriaLabel: function(){
            var self = this;
            this.$nextTick(function(){
                let section_title = $("#"+self.input.uid).closest('section').find('[id*="_qstn"]').text();
                let subtract_btn = self.$refs[self.input.uid+'_btn_subtract'];
                let add_btn = self.$refs[self.input.uid+'_btn_add'];
                let container_card = self.$refs[self.input.uid+'_card'];

                $('input#'+self.input.uid).attr('aria-label',"input field for: "+section_title + ". To control the data in this field please interact with the add and subtract buttons");
                
                subtract_btn.setAttribute('aria-label',"subtract button for the question: "+section_title);
                add_btn.setAttribute('aria-label',"add button for the question: "+section_title);
                container_card.setAttribute('aria-label',section_title);
            })
        }
    }
};
